<template>
  <div>
    <RegisterForm />
  </div>
</template>

<script>
import RegisterForm from "@/components/auth/RegisterForm";

export default {
  components: { RegisterForm },
};
</script>
